import MemberMention from "$components/editor/extensions/blocks/Members/MemberMention.svelte";
import { Node, mergeAttributes } from "@tiptap/core";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

export default Node.create({
  name: "memberInlineBlock",
  group: "inline",
  inline: true,
  draggable: true,
  atom: true,
  selectable: true,
  renderText({ node }) {
    // when copy/pasted to another app
    return `@${node.attrs.user.handle}`;
  },
  addAttributes() {
    return {
      user: {
        default: {},
        // serialise complex data to string
        // used when copy/pasting content
        parseHTML: (element) => JSON.parse(element.getAttribute("data-user") || ""),
        renderHTML: (attributes) => {
          return {
            "data-user": JSON.stringify(attributes.user),
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "mention-member-inline",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["mention-member-inline", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return SvelteNodeViewRenderer(MemberMention);
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          const { user } = node.attrs;

          // format as plain text prefixed with @
          state.write(`@${user.handle}`);
        },
      },
    };
  },
});
